import { Divider as BaseDivider } from '@unifyapps/ui/components/Divider';
import type { BlockComponentProps } from '@unifyapps/carbon/no-code/components/BlockRenderer/types';
import type { DividerComponentType, DividerBlockStateType } from '@unifyapps/defs/types/blocks';
import { useBlockAppearanceStyles } from '@unifyapps/carbon/no-code/hooks/useBlockAppearanceStyles';
import { useRegistryContext } from '@unifyapps/carbon/no-code/components/RegistryProvider';
import { isEmptyBlock } from '@unifyapps/carbon/no-code/utils/block';
import { memo } from 'react';
import { clsx } from 'clsx';

function Divider({
  attributesAndEventListeners,
  component,
  computedBlockState,
  dndRef,
}: BlockComponentProps<DividerComponentType, DividerBlockStateType, DividerBlockStateType>) {
  const { appearance } = computedBlockState;
  const { registry } = useRegistryContext();
  const BlockRenderer = registry.getBlockRenderer();

  const { className, style } = useBlockAppearanceStyles({
    appearanceStyles: appearance?.styles,
  });

  const { className: dimensionClassName, style: dimensionStyle } = useBlockAppearanceStyles({
    appearanceStyles: {
      ...(appearance?.orientation === 'horizontal'
        ? { height: computedBlockState.appearance?.height }
        : { width: computedBlockState.appearance?.width }),
    },
  });

  const adaptedStyle = { ...style, ...dimensionStyle };

  return (
    <BaseDivider
      className={clsx(className, dimensionClassName)}
      orientation={appearance?.orientation}
      style={adaptedStyle}
      {...attributesAndEventListeners}
      ref={dndRef}
    >
      {component.slots?.body?.blockId && !isEmptyBlock(component.slots.body.blockId) ? (
        <BlockRenderer blockId={component.slots.body.blockId} parentBlockId={null} />
      ) : null}
    </BaseDivider>
  );
}

export default memo(Divider);
